import { getSelectedDivisionId } from "app/shared/division/selectedDivisionStorage";

const SELECTED_CENTRE_STORAGE_KEY = "pricelistSelectedCentreCode";
const ACTIVE_PRODUCT_TYPE_STORAGE_KEY = "pricelistActiveProductType";

export const getDivisionId = (): number => getSelectedDivisionId();

export const readSelectedCentreCode = (): string | undefined => {
  const raw = localStorage.getItem(SELECTED_CENTRE_STORAGE_KEY);
  return raw && raw.trim() ? raw.trim() : undefined;
};

export const readStoredProductType = (): string | undefined => {
  try {
    const value = localStorage.getItem(ACTIVE_PRODUCT_TYPE_STORAGE_KEY);
    return value && value.trim() ? value.trim() : undefined;
  } catch {
    return undefined;
  }
};

export const writeSelectedCentreCode = (centreCode: string | undefined): void => {
  if (centreCode && centreCode.trim()) {
    localStorage.setItem(SELECTED_CENTRE_STORAGE_KEY, centreCode.trim());
  } else {
    localStorage.removeItem(SELECTED_CENTRE_STORAGE_KEY);
  }
};

export const toSchoolIdNumber = (input: unknown): number | undefined => {
  if (input === null || input === undefined) return undefined;

  if (typeof input === "object") {
    const c: any = input;
    if (c && "id" in c) return toSchoolIdNumber(c.id);
  }

  if (typeof input === "number") {
    return Number.isFinite(input) ? input : undefined;
  }

  const raw = String(input).trim();
  if (!raw) return undefined;

  const stripped = /^School-/i.test(raw)
    ? raw.replace(/^School-/i, "")
    : raw;
  const n = Number(stripped);
  return Number.isFinite(n) ? n : undefined;
};

export type SchoolSelectionValue = string;

export const extractSchoolSelectionValue = (
  input: unknown
): SchoolSelectionValue | null => {
  if (input === null || input === undefined) return null;

  if (typeof input === "object") {
    const candidate: any = input;
    if (candidate) {
      if ("id" in candidate) return extractSchoolSelectionValue(candidate.id);
      if ("code" in candidate)
        return extractSchoolSelectionValue(candidate.code);
    }
  }

  const raw = String(input).trim();
  if (!raw) return null;

  if (/^School-/i.test(raw)) {
    const suffix = raw.slice(raw.indexOf("-") + 1).trim();
    return suffix || null;
  }

  return raw;
};

// for test
export const parseSchoolId = (
    input: unknown,
    opts?: { defaultValue?: number | undefined }
): number | undefined => {
  const def = opts?.defaultValue;
  if (input == null) return def;

  if (typeof input === "object") {
    const c: any = input;
    if ("id" in c) return parseSchoolId(c.id, opts);
    if ("Id" in c) return parseSchoolId(c.Id, opts);
    if ("schoolId" in c) return parseSchoolId(c.schoolId, opts);
    if ("SchoolId" in c) return parseSchoolId(c.SchoolId, opts);
  }

  if (typeof input === "number") return Number.isFinite(input) ? input : def;

  const raw = String(input).trim();
  if (!raw) return def;

  const stripped = /^School-/i.test(raw) ? raw.replace(/^School-/i, "") : raw;
  const n = Number(stripped);
  return Number.isFinite(n) ? n : def;
};
